"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hiddenStyle = exports.visibleStyle = exports.closeButton = exports.variantStyle = exports.base = exports.boxShadow = exports.darkVariant = exports.lightVariant = exports.fullWidth = exports.size = exports.baseDescription = exports.baseTitle = exports.textColorStyle = exports.textContainer = exports.iconStyle = exports.baseIcon = exports.textStyles = void 0;
var react_1 = require("@emotion/react");
var tokens_1 = require("@prezzee/tokens");
var sizeStyles = {
    small: (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), tokens_1.spacing.spacing03),
    large: (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), tokens_1.spacing.spacing04),
};
var colorStyles = {
    light: {
        red: {
            text: tokens_1.colors.red600,
            background: tokens_1.colors.red50,
            icon: tokens_1.colors.red400,
            border: tokens_1.colors.red400,
        },
        green: {
            text: tokens_1.colors.green600,
            background: tokens_1.colors.green50,
            icon: tokens_1.colors.green400,
            border: tokens_1.colors.green400,
        },
        blue: {
            text: tokens_1.colors.blue600,
            background: tokens_1.colors.blue50,
            icon: tokens_1.colors.notificationBlue,
            border: tokens_1.colors.notificationBlue,
        },
        yellow: {
            text: tokens_1.colors.yellow700,
            background: tokens_1.colors.yellow50,
            icon: tokens_1.colors.yellow500,
            border: tokens_1.colors.yellow400,
        },
        purple: {
            text: tokens_1.colors.purple600,
            icon: tokens_1.colors.purple500,
            background: tokens_1.colors.purple50,
            border: tokens_1.colors.purple400,
        },
    },
    dark: {
        red: {
            background: tokens_1.colors.red500,
            text: tokens_1.colors.white,
            icon: tokens_1.colors.white,
        },
        green: {
            background: tokens_1.colors.green600,
            text: tokens_1.colors.white,
            icon: tokens_1.colors.white,
        },
        blue: {
            background: tokens_1.colors.blue500,
            text: tokens_1.colors.white,
            icon: tokens_1.colors.white,
        },
        purple: {
            background: tokens_1.colors.purple400,
            text: tokens_1.colors.white,
            icon: tokens_1.colors.white,
        },
        yellow: {
            background: tokens_1.colors.yellow600,
            text: tokens_1.colors.white,
            icon: tokens_1.colors.white,
        },
    },
};
exports.textStyles = {
    small: (0, react_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", ";\n    line-height: ", ";\n  "], ["\n    font-size: ", ";\n    line-height: ", ";\n  "])), tokens_1.spacing.spacing035, tokens_1.spacing.spacing06),
    large: (0, react_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: ", ";\n    line-height: ", ";\n  "], ["\n    font-size: ", ";\n    line-height: ", ";\n  "])), tokens_1.spacing.spacing04, tokens_1.spacing.spacing06),
};
exports.baseIcon = (0, react_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  svg {\n    width: ", ";\n    height: ", ";\n    margin-top: 3px; // Vertically centering\n  }\n"], ["\n  svg {\n    width: ", ";\n    height: ", ";\n    margin-top: 3px; // Vertically centering\n  }\n"])), tokens_1.spacing.spacing05, tokens_1.spacing.spacing05);
var iconStyle = function (variant, color) {
    var theme = colorStyles[variant][color];
    return (0, react_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    svg {\n      color: ", ";\n    }\n  "], ["\n    svg {\n      color: ", ";\n    }\n  "])), theme.icon);
};
exports.iconStyle = iconStyle;
exports.textContainer = (0, react_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  padding-left: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding-left: ", ";\n"])), tokens_1.spacing.spacing03);
var textColorStyle = function (variant, color) {
    var theme = colorStyles[variant][color];
    return (0, react_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), theme.text);
};
exports.textColorStyle = textColorStyle;
exports.baseTitle = (0, react_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  font-weight: 600;\n  margin-right: ", ";\n"], ["\n  font-weight: 600;\n  margin-right: ", ";\n"])), tokens_1.spacing.spacing03);
var baseDescription = function (variant) { return (0, react_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  font-weight: 400;\n  margin-top: ", ";\n  margin-right: ", ";\n  ", ";\n"], ["\n  font-weight: 400;\n  margin-top: ", ";\n  margin-right: ", ";\n  ", ";\n"])), tokens_1.spacing.spacing03, tokens_1.spacing.spacing03, variant === 'dark' ? "color: white" : "color: ".concat(tokens_1.colors.gray800)); };
exports.baseDescription = baseDescription;
var size = function (size) { return sizeStyles[size]; };
exports.size = size;
var fullWidth = function (fullWidth) {
    var width = fullWidth ? '100%' : 'fit-content';
    return (0, react_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    width: ", ";\n  "], ["\n    width: ", ";\n  "])), width);
};
exports.fullWidth = fullWidth;
var lightVariant = function (color) {
    var lightTheme = colorStyles.light[color];
    return (0, react_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    background-color: ", ";\n    border: 1px solid ", ";\n  "], ["\n    background-color: ", ";\n    border: 1px solid ", ";\n  "])), lightTheme.background, lightTheme.border);
};
exports.lightVariant = lightVariant;
var darkVariant = function (color) {
    var darkTheme = colorStyles.dark[color];
    return (0, react_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    background-color: ", ";\n    color: white;\n  "], ["\n    background-color: ", ";\n    color: white;\n  "])), darkTheme.background);
};
exports.darkVariant = darkVariant;
exports.boxShadow = (0, react_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.11);\n"], ["\n  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.11);\n"])));
exports.base = (0, react_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  display: flex;\n  border-radius: 5px;\n"], ["\n  display: flex;\n  border-radius: 5px;\n"])));
var variantStyle = function (color, variant) { return (0, react_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), variant === 'dark' && (0, exports.darkVariant)(color), variant === 'light' && (0, exports.lightVariant)(color)); };
exports.variantStyle = variantStyle;
var closeButton = function (variant) {
    var buttonColor = variant === 'light' ? tokens_1.colors.gray800 : tokens_1.colors.white;
    return (0, react_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    width: 20px;\n    height: 20px;\n    position: relative;\n    margin-top: 3px; // Helps with centering\n    margin-left: auto;\n\n    :hover {\n      cursor: pointer;\n      opacity: 0.7;\n      transition: opacity 0s 0.3s, opacity 0.3s linear;\n    }\n\n    :after {\n      content: '';\n      height: 20px;\n      border-left: 2px solid ", ";\n      position: absolute;\n      transform: rotate(45deg);\n      left: 10px;\n    }\n\n    :before {\n      content: '';\n      height: 20px;\n      border-left: 2px solid ", ";\n      position: absolute;\n      transform: rotate(-45deg);\n      left: 10px;\n    }\n  "], ["\n    width: 20px;\n    height: 20px;\n    position: relative;\n    margin-top: 3px; // Helps with centering\n    margin-left: auto;\n\n    :hover {\n      cursor: pointer;\n      opacity: 0.7;\n      transition: opacity 0s 0.3s, opacity 0.3s linear;\n    }\n\n    :after {\n      content: '';\n      height: 20px;\n      border-left: 2px solid ", ";\n      position: absolute;\n      transform: rotate(45deg);\n      left: 10px;\n    }\n\n    :before {\n      content: '';\n      height: 20px;\n      border-left: 2px solid ", ";\n      position: absolute;\n      transform: rotate(-45deg);\n      left: 10px;\n    }\n  "])), buttonColor, buttonColor);
};
exports.closeButton = closeButton;
exports.visibleStyle = (0, react_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  visibility: visible;\n  opacity: 1;\n"], ["\n  visibility: visible;\n  opacity: 1;\n"])));
exports.hiddenStyle = (0, react_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n  visibility: hidden;\n  opacity: 0;\n  transition: visibility 0s 0.3s, opacity 0.3s linear;\n"], ["\n  visibility: hidden;\n  opacity: 0;\n  transition: visibility 0s 0.3s, opacity 0.3s linear;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19;
//# sourceMappingURL=Alert.style.js.map